export default "__VITE_ASSET__CG0Aza3Z__"